module.exports = __webpack_public_path__ + "img/buliding.9e778411.svg";